import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { FreeZonePlateValue } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import { plateValue } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import {
  ONLY_NUMBERS_RULE,
  PERSIAN_LATTER_RULE,
} from '@/common/components/base/input/textInput/textInput.rules';
import PlateSelection from '@/common/components/plateSelection/PlateSelection';
import { NATIONAL_CODE_RULE } from '@/common/utils/rules/nationalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useFormContext, useWatch } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const AddDamagedVehicleRealForm = () => {
  const methods = useFormContext();
  const formData = useWatch({ control: methods.control });

  return (
    <>
      <RadioGroup
        wrapperClassName={css({ mt: '2rem', mb: '2rem' })}
        className={css({ gap: '2rem' })}
        title="جنسیت مالک"
        name="gender"
        options={[
          { label: 'آقا', value: 'male' },
          { label: 'خانم', value: 'female' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
      />
      <TextInput
        label="نام"
        name="first_name"
        placeholder="نام را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />
      <TextInput
        label="نام ‌خانوادگی"
        name="last_name"
        placeholder="نام ‌خانوادگی را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />
      <TextInput
        label="کدملی"
        name="national_code"
        placeholder="کدملی را وارد کنید"
        rules={{
          required: requiredText,
          ...ONLY_NUMBERS_RULE,
          ...NATIONAL_CODE_RULE,
        }}
        noCharInput
        max={10}
      />
      <PlateSelection
        plateDesign={formData.vehicle_plate_design?.value}
        onChangeFunctions={{
          freeZonePlateOnChange: (value) => {
            methods.setValue('plate', value);
          },
          plateDesignOnChange: () => {},
        }}
        values={{
          plate:
            formData.vehicle_plate_design?.value === 'county'
              ? (formData.plate as plateValue)
              : (formData.plate as FreeZonePlateValue),
        }}
        plateDesignName="vehicle_plate_design"
        vehiclePlateType={formData?.vehicle_type}
      />

      <Box mt="1.5rem">
        <MobileInput name="phone_number" />
      </Box>
    </>
  );
};

export default AddDamagedVehicleRealForm;
